/**
 * @file: number report
 * @author: wence
 */
import React, {PureComponent} from 'react';
import PropType from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Toast} from 'antd-mobile';

import {postNumberReport} from '../../actions/numberOptionsActions';
import './numberReport.less';

import {FormItem, CodePic} from './formCom';
import {validateRequire, validateMax, validateEmail} from './utils';

class NumberReport extends PureComponent {
    static propTypes = {
        postNumberReport: PropType.func,
        reportRes: PropType.object,
        match: PropType.object,
        userInfo: PropType.object
    }

    constructor(props) {
        super(props);

        this.state = {
            params: {
                type: '1',
                phone: this.getParams().phone || ''
            }
        };

        if (this.isPC()) {
            window.location.href = `/console/#/reportNumber?phone=${this.getParams().phone || ''}`;
        }
    }

    validate = [];

    componentDidUpdate(nextProps) {
        if (nextProps.userInfo !== this.props.userInfo
            && this.props.userInfo
            && this.props.userInfo.status !== 0
        ) {
            const url = location.pathname + location.search;
            const phone = this.getParams().phone;
            window.location.href = `/m/haoma/guide?url=${encodeURIComponent(url)}&phone=${phone || ''}`;
        }
    }

    onChange = (key, value) => {
        this.setState({params: {...this.state.params, [key]: value}});
    }

    onBlur = () => {
        if (this.isIOS) {
            this.setState({fixed: false});

            document.querySelector('.nav-bar').style.position = '';
        }

    }

    onFocus = () => {
        if (this.isIOS) {
            this.setState({fixed: true});

            document.querySelector('.nav-bar').style.position = 'absolute';
        }
    }

    onSubmit = async () => {
        let canSubmit = true;
        this.validate.map(fn => {
            const vilidate = fn();

            if (vilidate.validate && canSubmit) {
                canSubmit = false;
            }
        });

        if (canSubmit) {
            await this.props.postNumberReport(this.state.params);

            const reportRes = this.props.reportRes;
            if (reportRes.status === 0) {
                window.location.href = '/m/haoma/success/report';
            }
            else if (reportRes.status === 401) {
                window.location.href = this.loginUrl();
            }
            else {
                if (reportRes && reportRes.description) {
                    Toast.info(reportRes.description, 2);
                }
                this.codePic.resetCode();
                this.resetCaptcha();
            }
        }
    }

    resetCaptcha = () => {
        this.setState({params: {...this.state.params, captcha: ''}});
    }

    pushValidate = node => {
        if (node) {
            this.validate.push(node.validate);
        }
    }

    render() {
        return (
            <div className="number-report">
                <div className="number-report-title">
                    骚扰电话举报
                </div>
                <div className="number-report-wrapper">
                    <div className="form">
                        <FormItem
                            isRequire
                            value={this.state.params.phone}
                            onChange={this.onChange.bind(this, 'phone')}
                            className="first-form-item"
                            type="input"
                            des="请勿输入空格、连字符等特殊字符、座机请加区号"
                            label="举报号码："
                            placeholder="请输入座机、手机、400号码"
                            comClassName="form-input"
                            ref={this.pushValidate}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            rules={[validateRequire('举报号码'), {
                                validate(value) {
                                    let re = /^\d{6,25}$/;

                                    return !re.test(value);
                                },
                                message: '号码格式不正确！'
                            }]}
                        />
                        <FormItem
                            isRequire
                            type="select"
                            label="号码类型："
                            title="号码类型"
                            ref={this.pushValidate}
                            value={this.state.params.type}
                            onChange={this.onChange.bind(this, 'type')}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                            data={[
                                {label: '诈骗电话', value: 1},
                                {label: '保险电话', value: 2},
                                {label: '金融理财', value: 3},
                                {label: '中介电话', value: 4},
                                {label: '猎头电话', value: 5},
                                {label: '广告媒介', value: 6},
                                {label: '外卖送餐', value: 7},
                                {label: '快递公司', value: 8},
                                {label: '骚扰电话', value: 10},
                                {label: '违法电话', value: 11}
                            ]}
                            rules={[validateRequire('号码类型')]}
                        />
                        <FormItem
                            type="textarea"
                            label="举报原因："
                            value={this.state.params.reason}
                            onChange={this.onChange.bind(this, 'reason')}
                            placeholder="请简要描述举报原因（100字以内）"
                            rows={3}
                            ref={this.pushValidate}
                            comClassName="form-textarea"
                            rules={[validateMax('举报原因', 100)]}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        <FormItem
                            type="input"
                            label="联系邮箱："
                            comClassName="form-input"
                            value={this.state.params.email}
                            onChange={this.onChange.bind(this, 'email')}
                            placeholder="请输入您的邮箱"
                            ref={this.pushValidate}
                            rules={validateEmail()}
                            onBlur={this.onBlur}
                            onFocus={this.onFocus}
                        />
                        <div>
                            <FormItem
                                type="input"
                                label="验证码："
                                comClassName="form-input code"
                                value={this.state.params.captcha}
                                onChange={this.onChange.bind(this, 'captcha')}
                                placeholder="请输入验证码"
                                ref={this.pushValidate}
                                rules={[validateRequire('验证码')]}
                                renderRight={() => <CodePic
                                    resetCaptcha={this.resetCaptcha}
                                    ref={codePic => this.codePic = codePic} />}
                                onBlur={this.onBlur}
                                onFocus={this.onFocus}
                            />
                        </div>
                        <div onClick={this.onSubmit} className="number-options-btn">提交举报</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        reportRes: state.postNumberReport,
        userInfo: state.userLoginstate
    }),
    dispatch => bindActionCreators({postNumberReport}, dispatch)
)(NumberReport);



// WEBPACK FOOTER //
// ./src/containers/numberOptions/numberReport.js